import React from "react";
import Partner from "../../../types/Partner";
import ResultItem from "../resultItem/ResultItem";

interface TableContentProps {
  singleMarkerResult?: Partner;
  queryResults?: Partner[];
}

const TableContent = (props: TableContentProps) => {
  const { queryResults, singleMarkerResult } = props;

  return (
    <>
      {queryResults ? (
        queryResults.map((partner, index) => (
          <ResultItem
            key={partner.id}
            includeBgColor={index % 2 === 0 ? true : false}
            data={partner}
          />
        ))
      ) : (
        <ResultItem includeBgColor={true} data={singleMarkerResult} />
      )}
    </>
  );
};

export default TableContent;
